import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAddToCartWithBookCondition } from 'utils/customHooks/useAddToCartWithBookCondition';
import BookConditionChoiceModal from 'components/cart/BookConditionChoiceModal';
// helpers
import { capitalizeText, detailTypeProductRedirect } from 'helpers';
import PriceWithDiscount from 'components/priceWithDiscount/PriceWithDiscount';
//preview para libros sin portada
import preview from 'assets/img/preview.jpg';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import CoverImg from 'components/coverImage/CoverImage';
import Authors from 'components/authors';
import Button from 'components/userzone/buttons/ButtonCustom';
// icons
import { FaTrophy } from 'react-icons/fa';
//styles
import '../../pages/awardWinningBooksPage/awardWinningBooksPage.scss';

const Item = (props) => {
  const { t } = useTranslation(['home', 'detalle', 'cart']);
  const { data } = props;
  const { loading: cartFlowLoading, pendingProduct, requestAdd, confirmCondition, closeModal } =
    useAddToCartWithBookCondition();
  const { assignedLibrary } = useAssignedLibrary();

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  const tooltip = (
    <Tooltip id="tooltip" className="custom-tooltip">
      <h5 className="m-0 text-tooltip">{t('seeProduct')}</h5>
    </Tooltip>
  );

  const evaluateTitle = data?.titulo || data?.title;

  return (
    <>
    <OverlayTrigger placement="bottom" overlay={tooltip}>
      <div className="store-item position-relative">
        {props.isAward && (
          <p className="prizeName" title={props.prize.prize}>
            {props.prize.prize}
          </p>
        )}
        <div className="store-cover">
          {data?.is_awarded && (
            <div className="trophyDivItem">
              <FaTrophy />
            </div>
          )}
          <div
            className={'img-container' + (props.isReview ? ' img-review' : '')}
            style={{ cursor: props.isReview ? 'default' : 'pointer' }}
            data-testid="cover-img"
          >
            <div className="overlay"></div>
            <Link to={detailTypeProductRedirect(props.data, assignedLibrary)} onClick={goUp}>
              <CoverImg src={data?.get_url || data?.image || data?.cover || preview} className="cursor-default" />
            </Link>
            {props.isNew && (
              <div className="label-text-container novelty">
                <p className="label-text">{t('novelty', { ns: 'detalle' }).toUpperCase()}</p>
              </div>
            )}
            {data?.recommended && (
              <div className="label-text-container recommended">
                <p className="label-text">
                  {data?.bookstore_recommender?.name
                    ? t('bookstoreRecommender', { ns: 'detalle', name: data.bookstore_recommender.name }).toUpperCase()
                    : t('libreriaRecomienda', { ns: 'detalle' }).toUpperCase()}
                </p>
              </div>
            )}
          </div>
        </div>
        <Row className={`img-caption ${props.isAward && 'mb-0'}`}>
          <Col xs={12}>
            {!props.isReview ? (
              <Link className="store-item__link" to={detailTypeProductRedirect(props.data, assignedLibrary)}>
                <h5 className="title limit-long" title={evaluateTitle}>
                  {capitalizeText(evaluateTitle)}
                </h5>
              </Link>
            ) : (
              <h5 className="title limit-long" title={evaluateTitle}>
                {capitalizeText(evaluateTitle)}
              </h5>
            )}
          </Col>
          <Col xs={12} className="container-authors">
            {data?.authors && (
              <Authors elements={data?.authors} firstAuthorOnlyMobile={props.firstAuthorOnlyMobile} />
            )}
          </Col>
        </Row>
        {props.isAward ? (
          <p className="mb-3 black-color">{props.editorial}</p>
        ) : props.isReview ? (
          <Link
            className="blue text-center  style-link"
            to={`/${assignedLibrary}/pequenas-resenas/?small_reviews_id=${props.reviewId}`}
          >
            {t('watchMore')}
          </Link>
        ) : (
          <p className="store-item-price mb-1 justify-items-center">
            <PriceWithDiscount price={props.data?.price} discount={props.data?.discount} />
          </p>
        )}

        {!props.isReview && (
          <div className="text-center">
            <Button
              variant="outline-dark"
              size="sm"
              block="true"
              className={`${props?.childList ? 'goldenBtn' : ''} width-btn-add-cart`}
              onClick={() => requestAdd(data)}
              disabled={!props.data?.has_stock}
              loading={cartFlowLoading}
            >
              {props.data?.has_stock ? t('anadirCesta') : t('outOfStock')}
            </Button>
          </div>
        )}
      </div>
    </OverlayTrigger>
    <BookConditionChoiceModal
      show={!!pendingProduct}
      product={pendingProduct}
      onHide={closeModal}
      onConfirm={confirmCondition}
    />
    </>
  );
};

Item.propTypes = {
  data: PropTypes.object,
  isNew: PropTypes.bool,
  isAward: PropTypes.bool,
  isReview: PropTypes.bool,
  reviewId: PropTypes.string,
  prize: PropTypes.object,
  editorial: PropTypes.string,
  recommended: PropTypes.bool,
  firstAuthorOnlyMobile: PropTypes.bool
};

export default Item;
